import api from "../../api/api";

// creating user
const createUser = async (data) => {
  console.log("test", data);
  const response = await api.post("users/", data);
  console.log("test2", data);
  return response.data;

};

const getUser = async () => {
  const response = await api.get("users/");
  return response.data;
};

const getUserSlice = { getUser, createUser };

export default getUserSlice;
